export const BillSituation = {
  pago: "Pago",
  pagoParcial: "Pago Parcial",
  perda: "Perda",
  emAberto: "Em aberto",
  vencido: "Vencido",
}